import { useEffect, useState } from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Shield, X } from 'lucide-react';

export const ImpersonationMode = () => {
  const [isImpersonating, setIsImpersonating] = useState(false);
  const [impersonatedUser, setImpersonatedUser] = useState<string | null>(null);

  useEffect(() => {
    const impersonation = sessionStorage.getItem('impersonation_mode');
    if (impersonation) {
      const data = JSON.parse(impersonation);
      setIsImpersonating(true);
      setImpersonatedUser(data.userEmail);
    }
  }, []);

  const exitImpersonation = () => {
    sessionStorage.removeItem('impersonation_mode');
    window.location.href = '/admin';
  };

  if (!isImpersonating) {
    return null;
  }

  return (
    <Alert className="fixed top-0 left-0 right-0 z-50 border-b border-warning bg-warning/10 rounded-none">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Shield className="h-5 w-5 text-warning" />
          <AlertDescription className="text-sm font-medium">
            Impersonating: <span className="font-bold">{impersonatedUser}</span>
          </AlertDescription>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={exitImpersonation}
          className="gap-2"
        >
          <X className="h-4 w-4" />
          Exit Impersonation
        </Button>
      </div>
    </Alert>
  );
};
